module.exports = __webpack_public_path__ + "static/media/package_icon.10c10e05.png";